export const SUPPORTED_SEARCH_QUERY_PARAMETERS = {
  Adults: 'Adults',
  AirportPickup: 'AirportPickup',
  Amenities: 'Amenities',
  Children: 'Children',
  Delivery: 'Delivery',
  Drivable: 'Drivable',
  EndDate: 'EndDate',
  ExperienceNotRequired: 'ExperienceNotRequired',
  FestivalFriendly: 'FestivalFriendly',
  InstantBook: 'InstantBook',
  IsSuperhost: 'IsSuperhost',
  MaxLength: 'MaxLength',
  MaxPrice: 'MaxPrice',
  MaxRvYear: 'MaxRvYear',
  MaxWeight: 'MaxWeight',
  MinLength: 'MinLength',
  MinPrice: 'MinPrice',
  MinRvYear: 'MinRvYear',
  MinWeight: 'MinWeight',
  NeLat: 'NeLat',
  NeLng: 'NeLng',
  Page: 'Page',
  PetFriendly: 'PetFriendly',
  PlaceId: 'PlaceId',
  RVBrand: 'RVBrand',
  SearchAddress: 'SearchAddress',
  SortOrder: 'SortOrder',
  StartDate: 'StartDate',
  SwLat: 'SwLat',
  SwLng: 'SwLng',
  Towable: 'Towable',
  Types: 'Types',
  UnlimitedMileage: 'UnlimitedMileage',
} as const
Object.freeze(SUPPORTED_SEARCH_QUERY_PARAMETERS)
export type SUPPORTED_SEARCH_QUERY_PARAMETERS = (typeof SUPPORTED_SEARCH_QUERY_PARAMETERS)[keyof typeof SUPPORTED_SEARCH_QUERY_PARAMETERS]

/**
 * Ad click ID parameters, carried in the URL through every navigation (RVZ-28582).
 */
export const SUPPORTED_CLICK_ID_QUERY_PARAMETERS = {
  dclid: 'dclid',
  fbclid: 'fbclid',
  gbraid: 'gbraid',
  gclid: 'gclid',
  msclkid: 'msclkid',
  ttclid: 'ttclid',
  wbraid: 'wbraid',
} as const
Object.freeze(SUPPORTED_CLICK_ID_QUERY_PARAMETERS)
export type SUPPORTED_CLICK_ID_QUERY_PARAMETERS = (typeof SUPPORTED_CLICK_ID_QUERY_PARAMETERS)[keyof typeof SUPPORTED_CLICK_ID_QUERY_PARAMETERS]

export const SUPPORTED_QUERY_PARAMETERS = {
  ...SUPPORTED_SEARCH_QUERY_PARAMETERS,
  ...SUPPORTED_CLICK_ID_QUERY_PARAMETERS,
} as const
Object.freeze(SUPPORTED_QUERY_PARAMETERS)
export type SUPPORTED_QUERY_PARAMETERS = (typeof SUPPORTED_QUERY_PARAMETERS)[keyof typeof SUPPORTED_QUERY_PARAMETERS]
